import { AuthState } from '@okta/okta-auth-js';

import { TransactionTypesMassUpdates } from '../../services/backend/TransactionTypesMassUpdates';
import { useBaseApiClient } from '../useBaseApiClient';

export const useTransactionTypesMassUpdates: () => TransactionTypesMassUpdates<AuthState> = () => {
  return useBaseApiClient(TransactionTypesMassUpdates);
};
